module.exports = __webpack_public_path__ + "images/ciso.6f4be311.webp";